module.exports = __webpack_public_path__ + "img/im_scrollfeature_14@2x.6c57668a.jpg";